<template>
  <div v-if="showImages" class="campaign-box-image-container">
    <div v-if="showMobileImage" data-test-campaign-box-mobile-image class="hide-for-large">
      <img :src="images.mobileImage.url" :alt="images.mobileImage.alt" />
    </div>
    <div v-if="showDesktopImage" data-test-campaign-box-desktop-image class="show-for-large">
      <img :src="images.mainImage.url" :alt="images.mainImage.alt" />
    </div>
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BgImage',
  props: {
    images: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  computed: {
    showImages(): boolean {
      return this.images !== null;
    },
    showMobileImage(): boolean {
      return this.images.mobileImage !== null;
    },
    showDesktopImage(): boolean {
      return this.images.mainImage !== null;
    }
  }
});
</script>

<style lang="scss" scoped>
.campaign-box-image-container {
  position: relative;

  img {
    width: 100%;
  }
}
</style>
